import { ListenerEffectAPI } from '@reduxjs/toolkit'

import { addProduct } from '../features/checkout/checkoutSlice'
import { addNotification, clearNotification } from '../features/notifications/notificationSlice'
import { AppDispatch, RootState } from '../store'
import logger from '../utils/logger'
import { throwIfAborted } from './throwIfAborted'

const addItemNotificationMiddleware = async (
  action: ReturnType<typeof addProduct>,
  listenerAPI: ListenerEffectAPI<RootState, AppDispatch>,
) => {
  const productId = action.payload.product.id
  listenerAPI.cancelActiveListeners()
  const cartHasProduct = listenerAPI.getOriginalState().checkout.rows.some((row) => row.product.id === productId)
  listenerAPI.dispatch(
    addNotification({
      type: 'ADD_PRODUCT',
      productId,
      skipOpen: cartHasProduct,
    }),
  )
  await listenerAPI.delay(500)
  try {
    throwIfAborted(listenerAPI.signal)
    await listenerAPI.dispatch(clearNotification('ADD_PRODUCT' as const))
  } catch (err) {
    logger.debug({ label: 'addItemNotificationMiddleware', msg: 'canceled', err })
  }
}

const cartNotificationMiddleware = {
  effect: addItemNotificationMiddleware,
  matcher: addProduct.match,
} as const

export default cartNotificationMiddleware
